export const TAB = 'Tab';
export const BACKSPACE = 'Backspace';
export const ARROW_LEFT = 'ArrowLeft';
export const IE_LEFT = 'Left';
export const ARROW_RIGHT = 'ArrowRight';
export const IE_RIGHT = 'Right';
export const DELETE = 'Delete';
export const IE_DELETE = 'Del';
export const ENTER = 'Enter';
